import React from "react";
import Category, {CategoryData} from "./category";

/**
 *
 */
type Data = {
    categories : CategoryData[]
    embed : boolean
};

/**
 *
 * @param tags
 * @constructor
 */
export default function CategoryList ({ categories, embed } : Data)  {
    // render
    return (
        <>
            <div className="container p-0 m-0">
                <div className="row justify-content-md-between text-md-center">
                    {categories.map((category, index) =>
                        <>
                        {category.score ?
                            <Category
                                key={'category-' + category.id}
                                category={category}
                                embed={embed}
                            /> : ''
                        }
                        </>
                    )}
                </div>
            </div>
        </>
    );
}